const PARENT_ROUTES = {
  AUTH: "/auth",
  VENDORS: "/sourcing",
  CATALOGS: "/marketplace",
};

const appRoutes = {
  LOGIN: `${PARENT_ROUTES.AUTH}/login`,
  VERIFY_TOKEN: `${PARENT_ROUTES.AUTH}/verify`,
  VENDOR_PRODUCT_LIST: `${PARENT_ROUTES.VENDORS}/product`,
  VENDOR_PRODUCT_DETAILS: (id: string) =>
    `${PARENT_ROUTES.VENDORS}/product/${id}`,
  VENDOR_SERVICE_LIST: `${PARENT_ROUTES.VENDORS}/service`,
  VENDOR_SERVICE_DETAILS: (id: string) =>
    `${PARENT_ROUTES.VENDORS}/service/${id}`,
  VENDOR_LIST: `${PARENT_ROUTES.VENDORS}/vendor`,
  VENDOR_DETAILS: (id: string) => `${PARENT_ROUTES.VENDORS}/vendor/${id}`,
  MARKETPLACE_CATALOG_LIST: `${PARENT_ROUTES.CATALOGS}/catalog`,
  MARKETPLACE_CATALOG_DETAILS: (id: string) =>
    `${PARENT_ROUTES.CATALOGS}/catalog/${id}`,
  MARKETPLACE_COLLECTION_LIST: `${PARENT_ROUTES.CATALOGS}/collection`,
  MARKETPLACE_COLLECTION_DETAILS: (id: string) =>
    `${PARENT_ROUTES.CATALOGS}/collection/${id}`,
  SETTINGS_SALESFORCE_SYNC_LOG: "/settings/salesforce-sync-log",
};

export default appRoutes;
